export const UPDATE_SELECTED_TAGS = "UPDATE_SELECTED_TAGS";
export const RESET_FILTER = "RESET_FILTER";

export function updateSelectedTags(selectedTags) {
  return {
    type: UPDATE_SELECTED_TAGS,
    payload: selectedTags
  };
}

export function resetFilter() {
  return {
    type: RESET_FILTER
  };
}



// WEBPACK FOOTER //
// ./src/actions/tagFilter.js